import { updateAssetSize } from '../actions';
import { orchestrator } from 'satcheljs';
import patchAsset from '../utils/patchAsset';

orchestrator(
    updateAssetSize,
    ({ projectId, assetId, width, height, x, y, partialOriginalAsset }) => {
        patchAsset(
            projectId,
            assetId,
            { width, height, x, y },
            partialOriginalAsset,
            asset =>
                (width != 0 || height != 0) &&
                asset.bounds.width == width &&
                asset.bounds.height == height &&
                asset.bounds.x == x &&
                asset.bounds.y == y
        );
    }
);
